// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'play';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M2 2.598v12.804a1.107 1.107 0 0 0 .529.942 1.08 1.08 0 0 0 1.071.026l11.827-6.402a1.106 1.106 0 0 0 0-1.936L3.6 1.63a1.078 1.078 0 0 0-1.459.427A1.107 1.107 0 0 0 2 2.598z'
  />
);

export const viewBox = '0 0 18 18';
